import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddlocationpopupComponent } from '../../generalpopup/addlocationpopup/addlocationpopup.component';
import { AddbranchpopupComponent } from '../../generalpopup/addbranchpopup/addbranchpopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AddcontracttypepopupComponent } from '../../generalpopup/addcontracttypepopup/addcontracttypepopup.component';
import { AdddesignationpopupComponent } from '../../generalpopup/adddesignationpopup/adddesignationpopup.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
import { EmpfindComponent } from '../../empfind/empfind.component';

@Component({
  selector: 'app-addbulkempdetailschange',
  templateUrl: './addbulkempdetailschange.component.html',
  styleUrls: ['./addbulkempdetailschange.component.css']
})
export class AddbulkempdetailschangeComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "EmpDetailsChange";


  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  iscontracttypetypeaddmode: boolean = false;
  isvisadesignationaddmode: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;


  ismanualclose: boolean;

  isemploading: boolean = false;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filtercontracttypeid: any = null;
  filtercontracttypename: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  saveloading: boolean;

  //Edit Get Values
  empdetailschangeColl: any = [];
  empdetailschangeid: number = 0
  empdetailschangeBO: any = {}

  checkempColl: any = [];

  contracttypeColl: any = [];
  visadesignationColl: any = [];
  empColl: any = [];
  empBO: any = {}
  checkfeildmsg: any = "";

  empdetailschangeform = new FormGroup({
    empdetailschangeid: new FormControl(0),
    contracttypeid: new FormControl(null),
    empid: new FormControl(null),
    effectivedt: new FormControl(null, Validators.required),
    fromcontracttypeid: new FormControl(null),
    //adjdt:new FormControl(null,Validators.required),  
    //amount:new FormControl(''), 
    descr: new FormControl(''),
    iscontracttype: new FormControl(false),
    isvisadesignation: new FormControl(false),
    fromvisadesignationid: new FormControl(null),
    visadesignationid: new FormControl(null),
    isreportingmanager: new FormControl(false),
    fromreportingmanagerid: new FormControl(null),
    reportingmanagerid: new FormControl(null),
    transdt: new FormControl(null),
    inactive: new FormControl(false),
  });

  lastcontracttypename: string = ""
  lastcontracttypeid: any = null;

  lastcontractdate: any = null;

  lastvisadesignationname: string = ""
  lastvisadesignationid: any = null;

  lastreportingmanagername: string = ""
  lastreportingmanagerid: any = null;


  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.empdetailschangeid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.contracttypeid !== undefined) {
        this.filtercontracttypeid = params.contracttypeid
      }

      if (params.contracttypename !== undefined) {
        this.filtercontracttypename = params.contracttypename
      }

    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }




  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.empdetailschangeform.reset();
      this.fnInitializeFormGroup();

      if (this.empdetailschangeid > 0) {
        this.fngetEmpDetailsChange();
      }
      this.fngetEmployee();
      this.fngetContractType();
      this.fngetVisaDesignation();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.empdetailschangeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    this.iscontracttypetypeaddmode = this.loginService.fnCheckUserRoleAction("ContractType", 'CREATE')
    this.isvisadesignationaddmode = this.loginService.fnCheckUserRoleAction("Designation", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.empdetailschangeform.setValue({
      empdetailschangeid: 0,
      empid: null,
      contracttypeid: null,
      effectivedt: new Date(),
      fromcontracttypeid: null,
      descr: '',
      iscontracttype: false,
      isvisadesignation: false,
      fromvisadesignationid: null,
      visadesignationid: null,
      isreportingmanager: true,
      fromreportingmanagerid: null,
      reportingmanagerid: null,
      transdt: new Date(),
      inactive: false
    })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  fngetContractType() {
    var data = {
      'contracttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getContractType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.contracttypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetVisaDesignation() {
    var data = {
      'visadesignationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.visadesignationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Get 
  fngetEmpDetailsChange() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'empdetailschangeid': this.empdetailschangeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetEmpDetailsChange(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empdetailschangeColl = res.json().result;
            var editdata = this.empdetailschangeColl[0];
            this.empdetailschangeBO = editdata;
            this.fnEditMode(editdata);
            this.fnHideProgress();

          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.empdetailschangeform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }

  fnResetValidator() {

    if (this.loginService.fnCheckFornControlNotfound(this.empdetailschangeform.get('effectivedt'))) {
      this.empdetailschangeform.controls['effectivedt'].setErrors(null);
    }

    if (this.empdetailschangeform.get('iscontracttype')) {
      this.empdetailschangeform.controls['iscontracttype'].setErrors(null);
    }

    if (this.empdetailschangeform.get('contracttypeid')) {
      this.empdetailschangeform.controls['contracttypeid'].setErrors(null);
    }
    if (this.empdetailschangeform.get('visadesignationid')) {
      this.empdetailschangeform.controls['visadesignationid'].setErrors(null);
    }
    if (this.empdetailschangeform.get('inactive')) {
      this.empdetailschangeform.controls['inactive'].setErrors(null);
    }

  }


  fnValidation() {
    var _ischeck = false;


    if (this.loginService.fnCompareDateValidation(this.empdetailschangeform.get('effectivedt').value, this.empdetailschangeform.get('transdt').value)) {
      this.empdetailschangeform.controls['effectivedt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    if (!this.empdetailschangeform.get('iscontracttype').value && !this.empdetailschangeform.get('isvisadesignation').value && !this.empdetailschangeform.get('isreportingmanager').value) {
      this.empdetailschangeform.controls['iscontracttype'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    if (this.empdetailschangeform.get('iscontracttype').value) {

      if (this.empdetailschangeform.get('contracttypeid').value === null) {
        this.empdetailschangeform.controls['contracttypeid'].setErrors({ 'required': true });
        _ischeck = true;
      }

      if (this.empdetailschangeform.get('contracttypeid').value) {
        if (this.empdetailschangeform.get('contracttypeid').value === this.empdetailschangeform.get('fromcontracttypeid').value) {
          this.empdetailschangeform.controls['contracttypeid'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }

    }

    if (this.empdetailschangeform.get('isvisadesignation').value) {

      if (this.empdetailschangeform.get('visadesignationid').value === null) {
        this.empdetailschangeform.controls['visadesignationid'].setErrors({ 'required': true });
        _ischeck = true;
      }

      if (this.empdetailschangeform.get('visadesignationid').value) {
        if (this.empdetailschangeform.get('visadesignationid').value === this.empdetailschangeform.get('fromvisadesignationid').value) {
          this.empdetailschangeform.controls['visadesignationid'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }

    }


    if (this.empdetailschangeform.get('isreportingmanager').value) {

      if (this.empdetailschangeform.get('reportingmanagerid').value === null) {
        this.empdetailschangeform.controls['reportingmanagerid'].setErrors({ 'required': true });
        _ischeck = true;
      }

      if (this.empdetailschangeform.get('reportingmanagerid').value) {
        if (this.empdetailschangeform.get('reportingmanagerid').value === this.empdetailschangeform.get('fromreportingmanagerid').value) {
          this.empdetailschangeform.controls['reportingmanagerid'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }

    }


    if (this.checkempColl.length == 0) {
      this.empdetailschangeform.controls['inactive'].setErrors({ 'notfound': true });
      this.checkfeildmsg = "Select the Employee";
    }



    return _ischeck;

  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }


      this.submitted = true;
      this.successfully = false;


      this.fnResetValidator()

      //Validate
      if (this.empdetailschangeform.valid) {

        if (this.fnValidation()) {
          return false
        }

        this.saveloading = true;

        //Check
        var data = {
          'empdetailschangeid': this.empdetailschangeid,
          'effectivedt': this.fnFormatDatetime(this.empdetailschangeform.get('effectivedt').value),
          'transdt': this.fnFormatDatetime(this.empdetailschangeform.get('transdt').value),
          'empid': this.empdetailschangeform.get('empid').value,
          'contracttypeid': this.empdetailschangeform.get('contracttypeid').value,
          'fromcontracttypeid': this.empdetailschangeform.get('fromcontracttypeid').value,
          'descr': this.empdetailschangeform.get('descr').value,
          'iscontracttype': this.empdetailschangeform.get('iscontracttype').value,
          'isvisadesignation': this.empdetailschangeform.get('isvisadesignation').value,
          'fromvisadesignationid': this.empdetailschangeform.get('fromvisadesignationid').value,
          'visadesignationid': this.empdetailschangeform.get('visadesignationid').value,
          'isreportingmanager': this.empdetailschangeform.get('isreportingmanager').value,
          'fromreportingmanagerid': this.empdetailschangeform.get('fromreportingmanagerid').value,
          'reportingmanagerid': this.empdetailschangeform.get('reportingmanagerid').value,
          'inactive': this.empdetailschangeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'checkempColl': this.checkempColl
        }
        this.fnInsertEmpDetailsChange(data);

      }
      else {
        console.log(this.empdetailschangeform)
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertEmpDetailsChange(data) {

    this.appService.fnInsertEmpDetailsBulkChange(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new Employee Details Change has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            this.ismanualclose = true;
            this.fnCloseForm();
            // var _result = res.json().result;
            // if (_result.length > 0) {
            //   this.fnEditFormEdit(_result[0].empdetailschangeid);
            // }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetEmpDetailsChange(data) {

    this.appService.fnSetEmpDetailsChange(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The Employee Details Change has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.empdetailschangeid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.empdetailschangeid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  fnSelectEmployee() {

    const modalRef = this.productFindService.open(EmpfindComponent, { size: <any>'xxl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)
      if (this.checkempColl.length === 0) {
        for (let abo of receivedEntry) {
          this.checkempColl.push(abo)
        }
      }
      else {
        for (let abo of receivedEntry) {
          for (let pbo of this.checkempColl) {
            if (abo.empid !== pbo.empid) {
              this.checkempColl.push(abo)
            }
          }
        }

      }

    });
  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddBranch
  private fnAddContractType() {

    const modalRef = this.productFindService.open(AddcontracttypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetContractType();

      if (receivedEntry > 0) {
        this.empdetailschangeform.patchValue({ contracttypeid: receivedEntry })
      }
    });

  }
  //AddBranch
  private fnAddVisaDesignation() {

    const modalRef = this.productFindService.open(AdddesignationpopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      console.log(receivedEntry)

      this.fngetVisaDesignation();

      if (receivedEntry > 0) {
        this.empdetailschangeform.patchValue({ visadesignationid: receivedEntry })
      }
    });

  }
  fnEditFormEdit(id) {

    this.empdetailschangeid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'contracttypeid': this.filtercontracttypeid,
      'contracttypename': this.filtercontracttypename,
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });


  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'contracttypeid': this.filtercontracttypeid,
            'contracttypename': this.filtercontracttypename,
          }
        }

        this.router.navigate(['/EmpDetailsChange'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));

    this.empdetailschangeform.setValue({
      empdetailschangeid: deptBO.empdetailschangeid,
      empid: deptBO.empid,
      contracttypeid: deptBO.contracttypeid,
      fromcontracttypeid: deptBO.fromcontracttypeid,
      effectivedt: deptBO.effectivedt,
      descr: deptBO.descr,
      iscontracttype: deptBO.iscontracttype,
      isvisadesignation: deptBO.isvisadesignation,
      fromvisadesignationid: deptBO.fromvisadesignationid,
      visadesignationid: deptBO.visadesignationid,
      isreportingmanager: deptBO.isreportingmanager,
      fromreportingmanagerid: deptBO.fromreportingmanagerid,
      reportingmanagerid: deptBO.reportingmanagerid,
      transdt: deptBO.transdt,
      inactive: deptBO.inactive
    });


    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();

    this.lastcontracttypeid = deptBO.fromcontracttypeid;
    this.lastcontracttypename = deptBO.fromcontracttypename;
    this.lastvisadesignationid = deptBO.fromvisadesignationid;
    this.lastvisadesignationname = deptBO.fromvisadesignationname;
    this.lastreportingmanagerid = deptBO.fromreportingmanagerid;
    this.lastreportingmanagername = deptBO.fromreportingmanagername;


  }

  fnGetCurrentEmployeeDetails() {

    if (this.empdetailschangeid > 0) {
      return;
    }

    var empid = this.empdetailschangeform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {

        if (abo.empid === empid) {
          console.log(abo)
          this.lastcontracttypeid = abo.contracttypeid;
          this.lastcontracttypename = abo.contracttypename;
          this.lastvisadesignationid = abo.visadesignationid;
          this.lastvisadesignationname = abo.visadesignationname;
          this.lastreportingmanagerid = abo.reportingmanagerid;
          this.lastreportingmanagername = abo.visadesignationname;
        }
      }

    }
    else {
      this.lastcontracttypeid = null;
      this.lastcontracttypename = "";
      this.lastcontractdate = "";
      this.lastvisadesignationid = null;
      this.lastvisadesignationname = "";
      this.lastreportingmanagerid = null;
      this.lastreportingmanagername = "";
    }

    this.empdetailschangeform.patchValue({
      fromcontracttypeid: this.lastcontracttypeid
    })
    this.empdetailschangeform.patchValue({
      fromvisadesignationid: this.lastvisadesignationid,
    })
    this.empdetailschangeform.patchValue({
      fromreportingmanagerid: this.lastreportingmanagerid,
    })

  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetEmpDetailsChange();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.empdetailschangeBO.approvedstatus !== '') {
      if (this.empdetailschangeBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.empdetailschangeBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }

  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.empdetailschangeid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetEmpDetailsChange();
      }
    });



  }


  fnAttachmentSave(tid) {


  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }




  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.empdetailschangeid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetEmpDetailsChange();
      }


    });
  }


  //Attachment
  fnGetAttachmentCount() {
    if (this.empdetailschangeid > 0) {
      var data = {
        'trxid': this.empdetailschangeid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }
  fnAddActivity() {

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.empdetailschangeid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;

  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
